import React from 'react';
import { ScrollReveal } from './useScrollReveal';
export function PainPointsSection() {
  const painPoints = [{
    emoji: '💥',
    text: 'Cada conversación termina en pelea o en silencio incómodo'
  }, {
    emoji: '😶',
    text: 'Sienten que son compañeros de casa más que pareja'
  }, {
    emoji: '💸',
    text: 'El dinero genera tensión constante y nadie sabe cómo hablarlo'
  }, {
    emoji: '🔒',
    text: 'Los celos o la desconfianza están destruyendo algo que antes era sólido'
  }, {
    emoji: '👶',
    text: 'Los hijos los dividen en lugar de unirlos'
  }, {
    emoji: '😔',
    text: 'Hay resentimiento acumulado que ninguno sabe cómo sacar'
  }, {
    emoji: '📱',
    text: 'Las pantallas reemplazaron la conexión real'
  }, {
    emoji: '🔄',
    text: 'El lunes llega y todo vuelve a empezar igual'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 relative overflow-hidden cv-auto" data-id="element-185">
      {/* Decorative elements — reduced blur on mobile */}
      <div className="absolute -left-40 top-20 w-96 h-96 bg-red-500/5 rounded-full blur-[60px] md:blur-3xl pointer-events-none" data-id="element-186" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-187">
        <ScrollReveal direction="up" className="text-center mb-12" data-id="element-188">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-white" data-id="element-189">
            ¿Cuántos Días Más Vas a Pasar{' '}
            <span className="text-red-400" data-id="element-190">
              Sin Saber Cómo Salvar Tu Relación?
            </span>
          </h2>

          <p className="text-lg md:text-xl text-slate-300 mb-4 leading-relaxed" data-id="element-191">
            Querés que funcione. Los dos quieren. Pero nadie les enseñó cómo
            hablar sin que todo termine en pelea, cómo reconstruir la confianza
            después de una herida, o cómo volver a sentirse equipo cuando la
            rutina lo devoró todo.
          </p>

          <div className="inline-block bg-red-500/10 border border-red-500/20 text-red-300 font-semibold px-6 py-3 rounded-lg text-lg mt-4" data-id="element-192">
            No es falta de amor. Es falta de herramientas.
          </div>
        </ScrollReveal>

        <div className="bg-navy-800 border border-navy-700 rounded-2xl p-6 md:p-10 shadow-xl" data-id="element-193">
          <ul className="space-y-6" data-id="element-194">
            {painPoints.map((point, index) => <ScrollReveal as="li" key={index} direction="left" delay={index + 1} className="flex items-start gap-4" data-id="element-195">
                <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-196">
                  {point.emoji}
                </span>
                <span className="text-slate-200 text-lg" data-id="element-197">{point.text}</span>
              </ScrollReveal>)}
          </ul>
        </div>

        <ScrollReveal direction="up" className="text-center mt-16" data-id="element-198">
          <h3 className="text-2xl md:text-3xl font-bold text-gradient-blue" data-id="element-199">
            ¿Y Si Hoy Fuera el Último Día que Pasás Sin Saber Cómo Ayudar a Tu
            Relación?
          </h3>
        </ScrollReveal>
      </div>
    </section>;
}